import { useAuth } from "@/context/AuthContext";
import ParentDashboard from "@/pages/ParentDashboard";
import ChildDashboard from "@/pages/ChildDashboard";

export default function Dashboard() {
    const { isChild } = useAuth();
    return isChild ? <ChildDashboard /> : <ParentDashboard />;
}
